import axios from "axios";

const executePublicRequest = async (method, url, headers = {}, data) => {
  const baseUrl = `${process.env.REACT_APP_API}${url}`;

  const options = {
    method: method || "get",
    url: baseUrl,
    headers: {
      ...headers,
      "x-ignore-maintenance": true,
    },
  };

  if (data && ["post", "put", "patch"].includes(method.toLowerCase())) {
    options.data = data;
  }

  return axios.request(options);
};

const getRequest = (url, headers) => {
  return executePublicRequest("get", url, headers);
};

const postRequest = (url, data, headers) => {
  return executePublicRequest("post", url, headers, data);
};

const putRequest = (url, data, headers) => {
  return executePublicRequest("put", url, headers, data);
};

const patchRequest = (url, data, headers) => {
  return executePublicRequest("patch", url, headers, data);
};

const deleteRequest = (url, headers) => {
  return executePublicRequest("delete", url, headers);
};

export default {
  get: getRequest,
  post: postRequest,
  put: putRequest,
  patch: patchRequest,
  delete: deleteRequest,
};
